<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="tags" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="tagId" selectionMode="single"
  [(selection)]="tag" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="25"
  [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">Tags</h1>
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--manage categories-->
        <button pButton pRipple class="p-button-outlined"
          style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="onOpenManageCategories()">Manage Categories</button>

        <!--
          Find Order Products that have no reservation tag wired. Replaces the
          old standalone "OP → Tag Mapping" page; surfaces only the gap-finding
          feature that the tag table can't show on its own (tag-centric view
          structurally can't list OPs that have no tag row pointing at them).
        -->
        <button pButton pRipple class="p-button-outlined"
          style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
          pTooltip="Audit which order products have no reservation tag wired"
          tooltipPosition="bottom"
          (click)="onOpenOpCoverage()">
          <i class="pi pi-link" style="margin-right: 6px;"></i>Find OPs Missing Tags
        </button>

        <!--
          Sync missing Breezeway tags. Sweeps every reservation tag (tagType=8)
          where breezewayTagId is null, calls Breezeway's create-tag API for each,
          and saves the returned ids back. Hidden when none are missing so admins
          don't see a useless button.
        -->
        @if (missingBreezewayCount > 0) {
          <button pButton pRipple class="p-button-outlined p-button-warning"
            [disabled]="syncingBreezeway"
            style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
            (click)="onSyncMissingBreezeway()">
            <i class="pi pi-cloud-upload" style="margin-right: 6px;"></i>
            {{ syncingBreezeway ? 'Syncing…' : 'Sync ' + missingBreezewayCount + ' to Breezeway' }}
          </button>
        }

        <!--add new-->
        @if (!outlineNewButton) {
          <button pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">New Tag +</button>
        }
        @if (outlineNewButton) {
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">New Tag +</button>
        }
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': col.width || 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'tagId', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'name', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'description', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'tagGroupCategory', 'in')"></th>
        <!-- R3 — color column has no filter; sortable header above is enough -->
        <th [ngStyle]="{'width': '70px'}"></th>
        <th [ngStyle]="{'width': 'auto'}">
          <p-multiSelect class="multiselectdropdown" [options]="tagTypes" displaySelectedLabel
            optionLabel="name" optionValue="value" appendTo="body"  (onChange)="pt.filter($event.value, 'tagType', 'in');" optionLabel="name"
            display="chip"
          [displaySelectedLabel]="true"></p-multiSelect>
        </th>
        <th [ngStyle]="{'width': 'auto'}">
          <p-multiSelect class="multiselectdropdown" [options]="visibilities" displaySelectedLabel
            optionLabel="name" optionValue="value" appendTo="body"  (onChange)="pt.filter($event.value, 'visibility', 'in');" optionLabel="name"
            display="chip"
          [displaySelectedLabel]="true"></p-multiSelect>
        </th>
        <!-- R3 — breezewayTagId filter (numeric or empty) -->
        <th [ngStyle]="{'width': 'auto'}">
          <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text"
                 (input)="pt.filter($event.target.value, 'breezewayTagId', 'in')"
                 placeholder="bw id">
        </th>
        <!-- R1 (Approach A) — orderProductId filter -->
        <th [ngStyle]="{'width': 'auto'}">
          <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text"
                 (input)="pt.filter($event.target.value, 'orderProductId', 'in')"
                 placeholder="OP id">
        </th>
        <!-- R3 — owner filter -->
        <th [ngStyle]="{'width': 'auto'}">
          <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text"
                 (input)="pt.filter($event.target.value, 'ownedByUserVO.username', 'in')"
                 placeholder="owner">
        </th>
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-tag>
    <tr [pSelectableRow]="tag" [ngStyle]="isMissingBreezewayId(tag) ? {'background': '#fffbe6'} : null">
      <td>{{tag.tagId}} </td>
      <td>{{tag.name}}</td>
      <td>{{tag.description}}</td>
      <td>{{tag.tagGroupCategory}}</td>
      <!-- R4 — color swatch -->
      <td>
        @if (tag.tagColor) {
          <span pTooltip="{{tag.tagColor}}" tooltipPosition="top"
                [ngStyle]="{
                  'display': 'inline-block',
                  'width': '24px',
                  'height': '24px',
                  'border-radius': '4px',
                  'border': '1px solid #ccc',
                  'background-color': tag.tagColor
                }"></span>
        }
      </td>
      <td>{{getTagType(tag)}}</td>
      <td>{{getVisibility(tag)}}</td>
      <!-- R3 — Breezeway tag id with warning icon when missing on tagType=8 -->
      <td>
        @if (tag.breezewayTagId) {
          {{tag.breezewayTagId}}
        }
        @if (isMissingBreezewayId(tag)) {
          <i class="pi pi-exclamation-triangle"
             pTooltip="No Breezeway tag id assigned. Open the tag and use 'Pick from Breezeway…' to map one."
             tooltipPosition="top"
             style="color: #d97706;"></i>
        }
      </td>
      <!-- R1 (Approach A) — OP trigger: name + id, name resolved from the cached catalog. -->
      <td>
        @if (tag.orderProductId) {
          <span pTooltip="Auto-fired when this order product is added to a reservation"
                tooltipPosition="top">
            @if (getOrderProductName(tag.orderProductId)) {
              {{ getOrderProductName(tag.orderProductId) }}
              <small class="text-muted">(id {{ tag.orderProductId }})</small>
            } @else {
              <!-- catalog still loading or OP id unknown — fall back to id only -->
              id {{ tag.orderProductId }}
            }
          </span>
        }
      </td>
      <!-- R3 — owner display -->
      <td>{{tag.ownedByUserName}}</td>
      <td><span style="float:none">
        <a>
          <i class="pi pi-pencil" aria-hidden="true"
          style="color:blue; font-size:110%; padding-right:10px;" (click)="onOpenFormEdit(tag)"></i>
        </a>
        <a>
          <i class="pi pi-trash" aria-hidden="true"
          style="color:#c00; font-size:110%;" (click)="onRowDelete(tag)"></i>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>
